import React from "react";
import style from'./index.module.css';
import MapContainer from "../components/map-container";
import banner from "./image/banner.jpg";


function ConnectUs() {

  return (
    <>
      <div className={style.banner}>
        <img src={banner} alt="专注金融服务 创造信用财富" />
      </div>      
      <div className={style.content}>
        <ul>
          <li>联系我们</li>
          <li>CONTACT US</li>
          <li>联系电话：0755-82767942</li>
          <li>联系邮箱：rd@szrzrd.com</li>
          <li>联系地址：深圳市福田区福田街道福安社区益田路4068号卓越时代广场大厦4901-4905之4901A</li>
        </ul>
        <div className={style.map}>
          <MapContainer/>
        </div>
      </div>
    </>
  );
}

export default ConnectUs;
